export default __webpack_public_path__ + "static/media/zip.07571d35.svg";